import React from "react";
import { TInputLikeProps } from "../InputLike";
import * as S from "./styled";
import { withField } from "../Field";
import { IFieldContext } from "../../../constants";

export interface IProps
    extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "size">,
        IFieldContext,
        Omit<TInputLikeProps, "onClick"> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, IProps>(
    ({ className, style, error, disabled, lead, icon, trail, ...props }, ref) => {
        return (
            <S.TextAreaWrapper
                className={className}
                style={style}
                error={error}
                disabled={disabled}
                lead={lead}
                icon={icon}
                trail={trail}
            >
                <S.TextArea ref={ref} disabled={disabled} {...props} />
            </S.TextAreaWrapper>
        );
    }
);

export default withField(Textarea);
